import React from "react";
import { BasicChequeredBoard } from "../../components/BasicChequeredBoard";
import { BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { Links, LinksProps } from "../../components/Links";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";

export interface ElectricityDisconnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  chequeredBoard?: BasicChequeredBoardProps;
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const ElectricityDisconnectionPage: React.FC<ElectricityDisconnectionPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  chequeredBoard,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
      {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
